(function () {
  'use strict';

  angular
    .module('rosterStatusReportRadarChart')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('rosterStatusReportRadarChart', {
        url: '/roster-status-report-radar-chart/:autoScheduleSetupId?',
        params: {
          autoScheduleSetupId: null
        },
        views: {
          'rosterStatusReportRadarChartView': {
            templateUrl: 'roster-status-report-radar-chart/views/roster-status-report-radar-chart.tpl.html',
            controller: 'rosterStatusReportRadarChartCtrl',
            controllerAs: 'rosterStatusReportRadarChart'
          }
        }
      });
  }
}());
